import type { HTMLAttributes } from "react";

export const Brand = ({
  compact = false,
  className = "",
  ...props
}: HTMLAttributes<HTMLDivElement> & { compact?: boolean }) => (
  <div className={`brand ${compact ? "brand--compact" : ""} ${className}`} {...props}>
    <span className="brand__mark" aria-hidden="true">
      <svg viewBox="0 0 64 64">
        <path d="M13 38c12-2 16-13 21-25 5 10 13 15 21 17-8 3-14 8-18 16-6-5-14-7-24-8Z" />
        <path d="M18 39c10 0 20-5 29-15-5 11-13 19-24 24" />
      </svg>
    </span>
    <span>
      <strong>识羽</strong>
      {!compact && <small>看懂一只鸟，从关键特征开始</small>}
    </span>
  </div>
);
